<template>
  <div class="points">
    <div class="points_balance">
      <div class="balance">
        <span>积分余额 Integral balance</span>
        <span>{{ memberData.score }}</span>
      </div>
    </div>
    <div class="runing_water">积分明细 Integral detail</div>
    <div class="runing_list">
      <el-table :data="scoreList" style="width: 100%" :header-cell-style="{ background: '#FCFCFC' }">
        <el-table-column prop="createTime" label="变动时间 Variable time" width="360" align="center"> </el-table-column>
        <el-table-column prop="scoreNotag" label="变动额度 Variable quota" width="360" align="center">
        </el-table-column>
        <el-table-column prop="adjustTypeNotag" label="变动类型 Type of change" width="360" align="center">
        </el-table-column>
      </el-table>
    </div>
    <TablePage ref="list" @page-change="getScoreList" :total="total" :pageSizeNum="5"> </TablePage>
  </div>
</template>

<script>
import TablePage from "@/components/base/TablePage";
export default {
  name: "order",
  components: { TablePage },
  data() {
    return {
      memberData: {},
      scoreList: [],
      total: 0,
      pointsVisible: false,
      scoreType: {
        0: {name:"到店消费",nameEn:"In-store consumption"},
        1: {name:"注册",nameEn: "sign up"},
        2: {name:"签到",nameEn:"check in"},
        3: {name:"购物",nameEn:"Shopping"},
        4: {name:"订房",nameEn:"Reservation"},
        5: {name:"积分兑换",nameEn:"Points redemption"},
        6: {name:"取消订单",nameEn:"Cancel order"},
        7: {name:"退款",nameEn:"Refund"},
        8: {name:"客服调整",nameEn:"Customer Service Adjustments"},
        9: {name:"积分抵现",nameEn:"Points cash out"},
        10: {name:"积分过期",nameEn:"Points expired"},
        11: {name:"抽奖",nameEn:"lottery"},
        12: {name:"客服扣减钱包余额",nameEn:"Customer service deduction wallet balance"},
      },
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.searchHandler();
    this.getAccountsList();
  },
  methods: {
    // 初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    userRules() {
      this.pointsVisible = true;
    },
    async getAccountsList() {
      let { data } = await this.$api.getByUid();
      this.memberData = data;
    },
    async getScoreList(page, pageSize) {
      const params = {
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getScoreList(params);
        this.scoreList = (list || []).map((item) => {
          const scoreType=this.scoreType[item.adjustType]
          item.scoreNotag = item.score > 0 ? "+" + item.score : item.score;
          item.adjustTypeNotag = `${scoreType.name} ${scoreType.nameEn}`;
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.points {
  margin-top: 25px;
  .points_balance {
    width: 100%;
    height: 150px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    .balance {
      display: flex;
      flex-direction: column;
      
      color: #333333;
      span:first-child {
        font-size: 14px;
        font-weight: 400;
      }
      span:last-child {
        font-size: 36px;
        font-weight: bold;
        margin-top: 18px;
      }
    }
    .bonus {
      margin-left: 160px;
    }
    .rules {
      width: 152px;
      height: 40px;
      background: #333333;
      font-size: 16px;
      
      font-weight: 400;
      color: #ffffff;
      margin-left: 77px;
    }
  }
  .runing_water {
    font-size: 14px;
    
    font-weight: 400;
    color: #333333;
    margin: 61px 0 18px 0;
  }
  .runing_list {
    width: 1080px;
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
}
</style>
